import "./chunk-EUXUH3YW.js";

// libs/ui-components/src/lib/modules/icon/icons/link_16.svg.ts
import { svg } from "lit";
var link16Svg = svg`
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M6 12H5C4.47471 12 3.95457 11.8965 3.46927 11.6955C2.98396 11.4945 2.54301 11.1999 2.17157 10.8284C1.42143 10.0783 1 9.06087 1 8C1 6.93913 1.42143 5.92172 2.17157 5.17157C2.92172 4.42143 3.93913 4 5 4H6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M10 12H11C11.5253 12 12.0454 11.8965 12.5307 11.6955C13.016 11.4945 13.457 11.1999 13.8284 10.8284C14.5786 10.0783 15 9.06087 15 8C15 6.93913 14.5786 5.92172 13.8284 5.17157C13.0783 4.42143 12.0609 4 11 4H10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M5 8H11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export {
  link16Svg
};
//# sourceMappingURL=link_16.svg-ILSOSF3Q.js.map
